import type { Campaign } from '@/data'
import api from '..'

export interface CampaignPayload {
  name: string
  campaign_type?: string
  crm_disposition_mapping_ids?: number[]
}

export async function createCampaign(
  payload: CampaignPayload,
): Promise<Campaign> {
  const res = await api.post('/campaigns', payload)
  return res.data.data
}
